const $ = jQuery;

export default function filters() {
  initializeFilters();
  $(document).on('woof_ajax_done', function() {
    initializeFilters();
  });
}

function initializeFilters() {
  //Move product orderby dropdown
  var orderselect = $('.woocommerce-ordering').last();
  var destination = $('.woof_redraw_zone');
  orderselect.appendTo(destination);

  //Move reset button
  $('<li><a href="#" class="woof_reset_search_form" data-link="">Reset Filters</a><li>').prependTo($('.woof_products_top_panel ul'));
  //Hide empty filters
  $('.woof_checkbox_count,.woof_radio_count,.woof_select_count').each( function( index, item ) {
    if( "(0)" === item.innerHTML ) {
      parent = item.closest('li');
      if(parent) $( parent ).remove();
    }
  });

  //Remove filter categories with no filters left after removing empty filters
  $('.woof_container').each( function( ) {
    if(0 == $(this).find('.woof_checkbox_count,.woof_radio_count,.woof_select_count').length) {
      $(this).remove();
    }
  });

  $('.woof_container h4').on('touchstart', function(event) {
    event.preventDefault();
  });

  $('.woof_container h4').on('touchend', function(event) {
    event.preventDefault();
    $(event.target).parents('.woof_container').toggleClass('expanded');
  });

  $('.filter-drawer-toggle--filters').on('click touchend', function(event) {
    event.preventDefault();
    openMobileFilters();
  })
}

function openMobileFilters() {
  $('.woof').addClass('expanded');
  $('.scrim').stop();
  $('.scrim').fadeIn();
  $('.scrim').on('click touchend', function() {
    closeMobileFilters();
  });
}

function closeMobileFilters() {
  $('.woof').removeClass('expanded');
  $('.scrim').stop();
  $('.scrim').fadeOut();
}
